<template>
  <div style="background:#FFF;height:100%;">
    <el-container>
      <el-header>
        <el-row>
          <el-form :inline="true" :model="formInline" label-width="70px">
            <!-- <el-col :span="6">
              <el-form-item label="公司编码">
                <el-input v-model="formInline.areaCode" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>-->
            <el-col :span="6">
              <el-form-item label="公司名称">
                <el-input v-model="formInline.name" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <div class="handlePanel">
                <el-button type="primary" @click="getListDataBtn">查询</el-button>
                <el-button type="info" @click="resetBtn">重置</el-button>
              </div>
            </el-col>
          </el-form>
        </el-row>

        <el-row>
          <el-col :span="24">
            <div class="operatePanel">
              <el-button
                type="primary"
                @click="addBtn"
                icon="el-icon-plus"
                v-if="btnAuthorize.addBtn.btnEnable"
              >新增</el-button>
              <el-button
                type="primary"
                @click="showAmendMask"
                icon="el-icon-edit"
                v-if="btnAuthorize.modifyBtn.btnEnable"
              >修改</el-button>
              <el-button
                type="primary"
                @click="delGovInfo"
                icon="el-icon-delete"
                v-if="btnAuthorize.delBtn.btnEnable"
              >删除</el-button>
            </div>
          </el-col>
        </el-row>
      </el-header>

      <el-main ref="main">
        <el-table
          class="ownerTable"
          :data="tableData"
          border
          highlight-current-row
          @current-change="handleSelectDataChange"
          style="width: 100%;"
          height="100%"
        >
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <!-- <el-table-column prop="id" label="组织编码" :show-overflow-tooltip="true"></el-table-column> -->
          <el-table-column prop="name" label="组织名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <div class="block" style="display: flex;justify-content: space-between;">
          <span
            style="font-size: 14px;color:#666666;line-height:26px;margin-top:16px;"
          >显示{{(page-1)*rows + 1}}到{{page*rows > total ? total : page*rows}},共{{total}}记录</span>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20,30, 50 , 100]"
            :page-size.sync="rows"
            layout="sizes, prev, pager, next, jumper"
            :total="total"
            :current-page.sync="page"
          ></el-pagination>
        </div>
      </el-footer>
    </el-container>
    <!--配置弹窗-->
    <el-dialog
      class="maskBox"
      :visible.sync="isShowMaskBool"
      :title="isShowMaskBox==1?'新增组织信息':'修改组织信息'"
      :close-on-click-modal="false"
     
    >
      <el-form :model="addForm" :rules="rules" ref="infoForm" label-width="100px">
        <el-row>
           <el-col :span="22">
          <el-form-item label="组织名称"  prop="name">
            <el-input class="titleSelect" v-model="addForm.name" placeholder="请输入内容"></el-input>
          </el-form-item>
           </el-col>
        </el-row>
        <el-row>
           <el-col :span="22">
          <el-form-item label="备注" prop="remark">
            <el-input class="titleSelect" v-model="addForm.remark" placeholder="请输入内容"></el-input>
          </el-form-item>
           </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeBtn">取 消</el-button>
        <el-button type="primary" @click="updateBtn" v-show="isShowMaskBox==2">修改</el-button>
        <el-button type="primary" @click="saveaddBtn" v-show="isShowMaskBox==1">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getGovService, //组织列表
  addGovService, //添加组织
  modifyGovService, //修改组织
  deleteGovService //删除组织
} from "../../services/sysSettingService";

export default {
  name: "GoveSetting",
  data() {
    return {
      isShowMaskBool: false,
      isShowMaskBox: 0,
      addForm: {
        name: "", //组织名称
        remark: "" //组织备注
      },
      rules: {
        name: [
          { required: true, message: "请输入组织名称", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
        ],
         remark: [{ min: 1, max: 60, message: "备注长度必须介于1到60之间" }]
      },
      formInline: {
        name: ""
      },
      currentUserId: sessionStorage.getItem("currentUserId"),
      page: 1,
      rows: 20,
      total: null,
      tableData: [],
      selectTableItem: null,
      btnAuthorize: {
        addBtn: { key: "create", btnEnable: false },
        modifyBtn: { key: "update", btnEnable: false },
        delBtn: { key: "delete", btnEnable: false }
      }
    };
  },
  props: {
    menuCode: {
      type: String
    }
  },
  methods: {
    onActive(menuCode) {
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      this.matchedName = "";
      this.getListData();
    },

    getListDataBtn() {
      this.page = 1;
      this.getListData();
    },
    //获取数据列表
    getListData() {
      let reqParam = {
        name: this.formInline.name,
        pageIndex: this.page,
        pageSize: this.rows
      };
      getGovService(reqParam).then(
        res => {
          if (res.code == 10000000) {
            this.total = res.total;
            this.tableData = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },
    handleSelectDataChange(val) {
      console.log(val);
      this.selectTableItem = val;
    },

    //修改组织信息
    showAmendMask() {
      if (this.selectTableItem != null) {
        let reqParam = {
          id: this.selectTableItem.id
        };
        this.addForm.name = this.selectTableItem.name;
        this.addForm.remark = this.selectTableItem.remark;
        this.addForm.id = this.selectTableItem.id;

        this.isShowMaskBox = 2;
        this.isShowMaskBool = true;
      } else {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确认"
        });
      }
    },

    resetBtn() {
      this.formInline.name = "";
      this.formInline.remark = "";
      this.getListData();
    },

    addBtn() {
      this.isShowMaskBox = 1;
      this.isShowMaskBool = true;
      this.addForm = {
        name: "", //小区编码
        remark: "" //小区名称
      };
      this.$nextTick(() => {
        this.$refs.infoForm.resetFields();
      });
    },

    closeBtn() {
      this.amendLoading = false;
      this.isShowMaskBool = false;
      this.addForm.name = "";
      this.addForm.remark = "";
    },
    closeBtn1() {
      this.isShowMaskBox1 = false;
    },

    resetMatchedName() {
      this.matchedName = "";
      this.getListPartnerAreas();
    },
    saveaddBtn() {
      this.$refs["infoForm"].validate(valid => {
        if (valid) {
          let reqParam = {
            name: this.addForm.name,
            remark: this.addForm.remark,
            currentUserId: this.currentUserId
          };
          addGovService(reqParam).then(
            res => {
              if (res.code == 10000000) {
                this.$alert("新增成功", "提示", {
                  confirmButtonText: "确定"
                });
                this.closeBtn();
                this.getListData();
              } else {
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定"
                });
              }
            },
            err => {
              console.log("123");
              this.$alert(err, "提示", {
                confirmButtonText: "确定"
              });
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    updateBtn() {
      if (this.amendLoading) {
        return;
      }
      this.amendLoading = true;
      let reqParam = {
        id: this.selectTableItem.id,
        name: this.addForm.name,
        remark: this.addForm.remark,
        updateUserId: this.createUserId
      };
      modifyGovService(reqParam).then(
        res => {
          if (res.code == 10000000) {
            this.$alert("修改成功", "提示", {
              confirmButtonText: "确定"
            });
            this.closeBtn();
            this.getListData();
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },
    delGovInfo() {
      if (this.selectTableItem != null) {
        this.$confirm("确定删除该组织?", "提示", {
          confirmButtonText: "确认"
        }).then(() => {
          let reqParam = {
            orgId: this.selectTableItem.id
          };
          deleteGovService(reqParam).then(
            res => {
              if (res.code == 10000000) {
                this.$alert("删除成功", "提示", {
                  confirmButtonText: "确定"
                });
                this.getListData();
              } else {
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定"
                });
              }
            },
            err => {
              console.log("123");
              this.$alert(err, "提示", {
                confirmButtonText: "确定"
              });
            }
          );
        });
      } else {
        this.$alert("请选择一条数据", "提示", {
          confirmButtonText: "确认"
        });
      }
    },
    // 每页条数
    handleSizeChange(val) {
      this.rows = val;
      this.getListData();
    },
    // 当前页
    handleCurrentChange(val) {
      console.log("当前页" + val);
      this.page = val;
      this.getListData();
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.maskBox {
  width: 50%;
  height: 100%;
  left: 20%;
  text-align: center;
  top: 100px;
}
</style>
